/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Error_Edge_Target_TriggerInputs */

const cs_workflow_error_edge_target_trigger = /** @type {(inputs: Workflow_Error_Edge_Target_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spojení nesmí mířit na spouštěcí uzel.`)
};

const en_workflow_error_edge_target_trigger = /** @type {(inputs: Workflow_Error_Edge_Target_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edges cannot target trigger nodes.`)
};

/**
* | output |
* | --- |
* | "Edges cannot target trigger nodes." |
*
* @param {Workflow_Error_Edge_Target_TriggerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_error_edge_target_trigger = /** @type {((inputs?: Workflow_Error_Edge_Target_TriggerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Error_Edge_Target_TriggerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_error_edge_target_trigger(inputs)
	return cs_workflow_error_edge_target_trigger(inputs)
});